import React from 'react';
import Datatable from './Datatable';
import moment from 'moment';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const EventPill = ({ value }) => {
    const event = value ? value.toLowerCase() : 'unknown';

    return (
        <span
            className={classNames(
                'px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm whitespace-nowrap',
                event.startsWith('scale-down')
                    ? 'bg-green-100 text-green-700'
                    : null,
                event.startsWith('scale-up')
                    ? 'bg-orange-100 text-orange-700'
                    : null,
                event.startsWith('create')
                    ? 'bg-yellow-100 text-yellow-700'
                    : null,
                event.startsWith('delete')
                    ? 'bg-gray-200 text-gray-700'
                    : null
            )}
        >
            {event}
        </span>
    );
};

const CostPill = ({ event_type, cost }) => {
    const event = event_type ? event_type.toLowerCase() : 'unknown';
    const cost_string = `$${(cost.toFixed(3))} / day`;
    const cost_delta =
        event.startsWith('scale-down') || event.startsWith('delete')
            ? '-'
            : '+';

    return (
        <span
            className={classNames(
                'px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm whitespace-nowrap',
                event.startsWith('scale-down') || event.startsWith('delete')
                    ? 'bg-green-100 text-green-700'
                    : null,
                event.startsWith('scale-up') || event.startsWith('create')
                    ? 'bg-red-100 text-red-700'
                    : null
            )}
        >
            {`${cost_delta} ${cost_string}`}
        </span>
    );
};

const ElasticEventsTable = ({ data, loading }) => {
    //console.log(data)
    const column = [
        {
            header: 'Deployment Id',
            accessorKey: 'deployment_id',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            header: 'Deployment Name',
            accessorKey: 'deployment_name',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ cell }) => (
                <div className="whitespace-nowrap">{cell.getValue()}</div>
            ),
        },
        {
            header: 'Event',
            accessorKey: 'event_type',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ cell }) => <EventPill value={cell.getValue()} />,
        },
        {
            header: 'Old Config',
            accessorKey: 'old_config',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            header: 'New Config',
            accessorKey: 'new_config',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            header: 'Cost',
            accessorKey: 'cost',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ cell, row }) => (
                <CostPill
                    event_type={row.getValue('event_type')}
                    cost={cell.getValue()}
                />
            ),
        },
        {
            header: 'Event Time(IST)',
            accessorKey: 'created_at',
            muiTableHeadCellProps: {
                align: 'left',
            },
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
    ];
    return (
        
        <Datatable data={data} columns={column} loading={loading}/>
        
    );
};

export default ElasticEventsTable;
